<template>
  <div class="modal fade" tabindex="false" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="x-button">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </slot>
          <h4 class="modal-title">
            <slot name="header"></slot>
          </h4>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Dismiss</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  ready () {
    let modals = $('.modal')
    for (let i = 0; i < modals.length; i++) {
      let modal = modals[i]
      $(modal).on('hidden.bs.modal', function (e) {
        let hasModals = $('.modal')
        if (hasModals.length > 1) {
          $('body').addClass('modal-open')
        }
      })
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?6f9dd11a